import { useMemo } from "react";
import SyncTimesheetModal from ".";
import { useVisible } from "../../../../../utils/hooks/useVisible";

export const useSyncTimesheetModal = () => {
    const { visible, open, close, selected } = useVisible();

    const modal = useMemo(() => {
        return (
            <SyncTimesheetModal
                isOpen={visible}
                values={selected}
                close={close}
            />
        );
    }, [visible, selected, close]);

    return [open, modal];
}
